<template>
  <v-container fluid>
    <v-layout lg12 md12 mb-3>
      <v-flex text-lg-right>
        <v-icon dark class="mr-2" @click="createCus()">
          person_add
        </v-icon>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-dialog
        v-model="isDialogCreateCustomerShown"
        persistent
        max-width="550px"
        min-height="1050px"
      >
        <v-card dark>
          <v-toolbar flat>
            <v-toolbar-title>Create User</v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- <v-btn @click="isDialogCreateCustomerShown = false" icon>
              <v-icon>close</v-icon>
            </v-btn> -->
          </v-toolbar>
          <v-card-text>
            <v-text-field
              v-model="username"
              :rules="[rules.required]"
              label="Username"
            />
            <v-text-field
              v-model="password"
              :type="show ? 'text' : 'password'"
              :rules="[rules.required, rules.min]"
              :append-icon="show ? 'visibility' : 'visibility_off'"
              label="Password"
              hint="At least 6 characters"
              counter
              @click:append="show = !show"
            />
            <v-select
              v-model="partner"
              :items="partner_item"
              :rules="[rules.required]"
              label="Partner"
            />
            <v-text-field
              v-model="index"
              :rules="[rules.required]"
              label="Index"
            />
            <v-text-field
              v-model="instance"
              :prefix="instancePrefix"
              :rules="[rules.required]"
              label="Instance"
            />
            <v-text-field
              v-model="lic"
              :rules="[rules.required]"
              label="License (POC or Number)"
            />
            <v-menu
              v-if="lic && lic !== 'POC'"
              v-model="isPickerStartShown"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              offset-y
              full-width
              min-width="300px"
            >
              <template #activator="{ on }">
                <v-text-field
                  v-model="startDate"
                  label="Start Date"
                  prepend-icon="event"
                  v-on="on"
                />
              </template>

              <v-date-picker
                v-model="startDate"
                dark
                @input="isPickerStartShown = false"
              >
                <v-spacer />
              </v-date-picker>
            </v-menu>

            <v-menu
              v-if="lic && lic !== 'POC'"
              v-model="isPickerStartEndShown"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              offset-y
              full-width
              min-width="300px"
            >
              <template #activator="{ on }">
                <v-text-field
                  v-model="endDate"
                  label="End Date"
                  prepend-icon="event"
                  v-on="on"
                />
              </template>

              <v-date-picker
                v-model="endDate"
                dark
                @input="isPickerStartEndShown = false"
              >
                <v-spacer />
              </v-date-picker>
            </v-menu>
          </v-card-text>
          <v-card-actions>
            <v-btn slot="activator" flat icon @click="conCreate()">
              <v-icon>check</v-icon>
            </v-btn>
            <v-btn
              slot="activator"
              flat
              icon
              @click.native="isDialogCreateCustomerShown = false"
            >
              <v-icon>cancel</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout>
      <v-dialog
        v-model="isDialogEditUserShown"
        persistent
        max-width="550px"
        min-height="1050px"
      >
        <v-card dark>
          <v-toolbar flat>
            <v-toolbar-title>Edit User</v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- <v-btn @click="isDialogEditUserShown" = false" icon>
              <v-icon>close</v-icon>
            </v-btn> -->
          </v-toolbar>
          <!-- <v-card-title>Edit User</v-card-title> -->
          <v-card-text>
            <v-text-field
              v-model="customer_name"
              :rules="[rules.required]"
              label="Customer Name"
            />
            <v-text-field
              v-model="customer_name_eng"
              :rules="[rules.required]"
              label="Customer Name ENG"
            />
            <v-text-field
              v-model="username"
              :rules="[rules.required]"
              label="Username"
            />
            <v-text-field
              v-model="index"
              :rules="[rules.required]"
              label="Index"
            />
            <v-text-field
              v-model="lic"
              :rules="[rules.required]"
              label="License"
            />
            <v-text-field
              v-model="instance"
              :rules="[rules.required]"
              label="Instance"
            />
            <v-text-field
              v-model="online_retention"
              :rules="[rules.required]"
              type="number"
              label="Online Retention"
            />
            <v-text-field
              v-model="offline_retention"
              :rules="[rules.required]"
              type="number"
              label="Offline Retention"
            />
            <v-flex>
              <v-menu
                v-model="isPickerStartDateShown"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                offset-y
                full-width
                min-width="300px"
              >
                <template #activator="{ on }">
                  <v-text-field
                    v-model="start_date"
                    :rules="[rules.required]"
                    label="Start Date"
                    prepend-icon="event"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="start_date"
                  :max="end_date"
                  dark
                  @input="isPickerStartDateShown = false"
                >
                  <v-spacer />
                </v-date-picker>
              </v-menu>
              <v-menu
                v-model="isPickerStartDateTimeShown"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                offset-y
                full-width
                min-width="300px"
              >
                <template #activator="{ on }">
                  <v-text-field
                    v-model="startDateTime"
                    :rules="[rules.required]"
                    label="Start time (UTC)"
                    prepend-icon="access_time"
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  v-if="isPickerStartDateTimeShown"
                  v-model="startDateTime"
                  dark
                  @click:minute="isPickerStartDateTimeShown = false"
                />
              </v-menu>
            </v-flex>
            <v-flex>
              <v-menu
                v-model="isPickerEndDateShown"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                offset-y
                full-width
                min-width="300px"
              >
                <template #activator="{ on }">
                  <v-text-field
                    v-model="end_date"
                    :rules="[rules.required]"
                    label="End Date"
                    prepend-icon="event"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="end_date"
                  :min="start_date"
                  dark
                  @input="isPickerEndDateShown = false"
                >
                  <v-spacer />
                </v-date-picker>
              </v-menu>
              <v-menu
                v-model="isPickerEndDateTimeShown"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                offset-y
                full-width
                min-width="300px"
              >
                <template #activator="{ on }">
                  <v-text-field
                    v-model="endDateTime"
                    :rules="[rules.required]"
                    label="End time (UTC)"
                    prepend-icon="access_time"
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  v-if="isPickerEndDateTimeShown"
                  v-model="endDateTime"
                  dark
                  @click:minute="isPickerEndDateTimeShown = false"
                />
              </v-menu>
              <v-switch v-model="is2FAEnabled" label="Enable 2FA" />
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn slot="activator" flat icon @click="saveUser()">
              <v-icon>check</v-icon>
            </v-btn>
            <v-btn
              slot="activator"
              flat
              icon
              @click.native="isDialogEditUserShown = false"
            >
              <v-icon>cancel</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout>
      <v-dialog v-model="isDialogDeleteUserShown" max-width="210px">
        <v-layout justify-center>
          <v-card>
            <v-card-title>Confirm Delete</v-card-title>
            <v-card-actions>
              <v-btn color="primary" dark @click="conDelete()">
                Confirm
              </v-btn>
              <v-btn
                color="primary"
                dark
                @click="isDialogDeleteUserShown = false"
              >
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-layout>
      </v-dialog>
    </v-layout>
    <v-layout row justify-center>
      <v-flex lg12 md12>
        <v-card dark>
          <v-card-title>
            Customer Details
            <v-spacer />
            <v-text-field
              v-model="search"
              label="Search"
              single-line
              append-icon="search"
              hide-details
            />
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="customers"
            :search="search"
            :loading="loadTable"
            :pagination.sync="pagination"
          >
            <v-progress-linear
              slot:progress
              color="blue"
              indeterminate
            ></v-progress-linear>
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">{{ props.item.customer_name }}</td>
              <td class="text-xs-center">{{ props.item.customer_name_eng }}</td>
              <td class="text-xs-left">{{ props.item.username }}</td>
              <td class="text-xs-left">{{ props.item.index }}</td>
              <td class="text-xs-center">{{ props.item.lic }}</td>
              <td class="text-xs-left">{{ props.item.instance }}</td>
              <td class="text-xs-center">
                {{ props.item.start_date.toDateString() }}
              </td>
              <td class="text-xs-center">
                {{ props.item.end_date.toDateString() }}
              </td>
              <td class="text-xs-center">
                {{ props.item.online_retention }}
              </td>
              <td class="text-xs-center">
                {{ props.item.offline_retention }}
              </td>
              <td class="text-xs-center">
                {{ props.item.remainingTime }}
              </td>
              <td class="justify-center layout px-0">
                <v-icon small class="mr-2" @click="editItem(props.item)">
                  build
                </v-icon>
                <v-icon small class="mr-2" @click="deleteItem(props.item)">
                  delete_outline
                </v-icon>
              </td>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >
              Your search for "{{ search }}" found no results.
            </v-alert>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import jwtDecode from "jwt-decode";
export default {
  name: "CustomerDetail",
  data() {
    return {
      // table zone
      customers: [],
      search: "",
      headers: [
        {
          text: "Customer Name",
          value: "customer_name",
          align: "center",
          sortable: true
        },
        {
          text: "Customer Name ENG",
          value: "customer_name_eng",
          align: "center",
          sortable: true
        },
        {
          text: "Username",
          value: "username",
          align: "left",
          sortable: true
        },
        {
          text: "Index Name",
          value: "index",
          align: "left",
          sortable: true
        },
        {
          text: "License",
          value: "lic",
          align: "center",
          sortable: true
        },
        {
          text: "Instance",
          value: "instance",
          align: "center",
          sortable: true
        },
        {
          text: "Start Date",
          value: "start_date",
          align: "center",
          sortable: true
        },
        {
          text: "End Date",
          value: "end_date",
          align: "center",
          sortable: true
        },
        {
          text: "Online Retention",
          value: "online_retention",
          align: "center",
          sortable: true
        },
        {
          text: "Offline Retention",
          value: "offline_retention",
          align: "center",
          sortable: true
        },
        {
          text: "Remaining day",
          value: "remainingTime",
          align: "center",
          sortable: false
        },
        {
          text: "Actions",
          value: "name",
          align: "center",
          sortable: false
        }
      ],
      pagination: {
        descending: false,
        rowsPerPage: 25,
        sortBy: "username"
      },
      loadTable: false,
      // Picker zone
      isPickerStartDateShown: false,
      isPickerStartDateTimeShown: false,
      isPickerEndDateShown: false,
      isPickerEndDateTimeShown: false,
      // dialog zone
      isDialogCreateCustomerShown: false,
      isDialogEditUserShown: false,
      isDialogDeleteUserShown: false,
      // data zone
      editid: "",
      deleteid: "",
      customer_name: "",
      is2FAEnabled: false,
      customer_name_eng: "",
      username: "",
      partner: "",
      index: "",
      lic: "",
      instance: "",
      instancePrefix: "http://3.1.180.118:",
      start_date: "",
      startDateTime: "",
      end_date: "",
      endDateTime: "",
      offline_retention: 0,
      online_retention: 0,
      password: "",
      partner_item: [
        {
          text: "AIS",
          value: "AIS"
        },
        {
          text: "DIRECT",
          value: "DIRECT"
        }
      ],
      // rule
      rules: {
        required: v => !!v || "This field is required.",
        min: v => v.length >= 6 || "Min 6 characters"
      },
      show: false,
      isPickerStartShown: false,
      isPickerStartEndShown: false,
      startDate: new Date().toISOString().substr(0, 10),
      endDate: new Date(new Date().getTime() + 365 * 24 * 60 * 60 * 1000)
        .toISOString()
        .substr(0, 10),
      token: null,
      ampid: null
    };
  },
  created() {
    this.token = sessionStorage.getItem("user-token");
    let decoded = jwtDecode(this.token);
    this.ampid = decoded.ampid;
    this.getCustomerDetails();
  },

  computed: {
    fullStartDate: function() {
      return new Date(this.startDate);
    },

    fullEndDate: function() {
      return new Date(this.endDate);
    }
  },

  methods: {
    async getCustomerDetails() {
      this.loadTable = true;
      try {
        let response = await axios.get(`${apiUrl}/api/auth/customerDetail`);
        if (response.data.success) {
          this.customers = response.data.users.map(user => {
            user.index = user.index.join();
            if (!user.start_date) {
              user.start_date = new Date(0).toISOString();
            }
            if (!user.end_date) {
              user.end_date = new Date(Date.now()).toISOString();
            }
            if (!user.online_retention) {
              user.online_retention = 30;
            }
            if (!user.offline_retention) {
              user.offline_retention = 90;
            }
            user.start_date = new Date(user.start_date);
            user.end_date = new Date(user.end_date);
            user.online_retention = user.online_retention;
            user.offline_retention = user.offline_retention;
            user.remainingTime =
              user.end_date - Date.now() <= 0
                ? "EXPIRED"
                : Math.round(
                    (user.end_date - Date.now()) / (1000 * 60 * 60 * 24)
                  );
            user.is2FAEnabled = user.is2FAEnabled;
            return user;
          });
        } else {
          throw new Error(response.data.msg);
        }
        this.loadTable = false;
      } catch (error) {
        console.error(error);
        alert("Server error");
      }
    },
    async editItem(item) {
      this.editid = item._id;
      this.customer_name = item.customer_name;
      this.customer_eng = item.customer_eng;
      this.username = item.username;
      this.index = item.index;
      this.lic = item.lic;
      this.instance = item.instance;
      this.online_retention = item.online_retention;
      this.offline_retention = item.offline_retention;
      this.start_date = item.start_date.toISOString().substring(0, 10);
      this.startDateTime = item.start_date.toISOString().substring(11, 16);
      this.end_date = item.end_date.toISOString().substring(0, 10);
      this.endDateTime = item.end_date.toISOString().substring(11, 16);
      this.isDialogEditUserShown = true;
      this.is2FAEnabled = item.is2FAEnabled;
    },
    async saveUser() {
      try {
        let response = await axios.post(
          `${apiUrl}/api/auth/editCustomer/${this.editid}`,
          {
            customer_name: this.customer_name,
            customer_name_eng: this.customer_name_eng,
            username: this.username,
            index: this.index.split(","),
            lic: this.lic,
            instance: this.instance,
            // start_date: this.start_date,
            start_date: new Date(`${this.start_date}T${this.startDateTime}:00`),
            end_date: new Date(`${this.end_date}T${this.endDateTime}:00`),
            online_retention: this.online_retention,
            offline_retention: this.offline_retention,
            // end_date: this.end_date
            is2FAEnabled: this.is2FAEnabled
          }
        );
        if (response.data.success) {
          window.analytics.track(
            `[Administrator][Customer Detail][Action][Edit]`,
            {
              value: {
                customer_name: this.customer_name,
                username: this.username,
                index: this.index.split(","),
                lic: this.lic,
                instance: this.instance,
                // start_date: this.start_date,
                start_date: new Date(
                  `${this.start_date}T${this.startDateTime}:00`
                ),
                end_date: new Date(`${this.end_date}T${this.endDateTime}:00`),
                online_retention: this.online_retention,
                offline_retention: this.offline_retention
              }
            },
            {
              integrations: {
                Amplitude: {
                  session_id: this.ampid
                }
              }
            }
          );
          alert(response.data.msg);
          this.isDialogEditUserShown = false;
          this.getCustomerDetails();
        } else {
          throw new Error(response.data.msg);
        }
      } catch (error) {
        alert(error);
      }
    },
    deleteItem(item) {
      this.deleteid = item._id;
      this.username = item.username;
      this.isDialogDeleteUserShown = true;
    },
    async conDelete() {
      try {
        let response = await axios.post(
          `${apiUrl}/api/auth/deleteCustomer/${this.deleteid}`,
          {
            username: this.username
          }
        );
        window.analytics.track(
          `[Administrator][Customer Detail][Action][Delete]`,
          {
            value: {
              username: this.username
            }
          },
          {
            integrations: {
              Amplitude: {
                session_id: this.ampid
              }
            }
          }
        );
        alert(response.data.msg);
        this.isDialogDeleteUserShown = false;
        this.getCustomerDetails();
      } catch (error) {
        alert(error);
      }
    },
    createCus() {
      this.username = "";
      this.password = "";
      this.partner = "";
      this.index = "";
      this.instance = "";
      this.lic = "";
      this.isDialogCreateCustomerShown = true;
    },
    async conCreate() {
      try {
        let response = await axios.post(`${apiUrl}/api/auth/createCustomer/`, {
          username: this.username,
          password: this.password,
          partner: this.partner,
          index: this.index.split(","),
          instance: this.instancePrefix + this.instance,
          lic: this.lic,
          startDate:
            this.lic === "POC"
              ? new Date(Date.now()).toISOString()
              : this.fullStartDate,
          endDate:
            this.lic === "POC"
              ? new Date(Date.now() + 1814400000).toISOString()
              : this.fullEndDate,
          onlineRegister: 30,
          offlineRegister: 90
        });
        alert(response.data.msg);
        this.isDialogCreateCustomerShown = false;
        this.getCustomerDetails();
      } catch (error) {
        alert(error);
      }
    }
  },
  watch: {
    search: function() {
      window.analytics.track(
        `[Administrator][Customer Detail][Search]`,
        {
          value: {
            keyword: this.search
          }
        },
        {
          integrations: {
            Amplitude: {
              session_id: this.ampid
            }
          }
        }
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/customerDetail.vue